import { render, staticRenderFns } from "./deleteResourceStore.vue?vue&type=template&id=352bea5c&scoped=true"
import script from "./deleteResourceStore.vue?vue&type=script&lang=js"
export * from "./deleteResourceStore.vue?vue&type=script&lang=js"
import style0 from "./deleteResourceStore.vue?vue&type=style&index=0&id=352bea5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352bea5c",
  null
  
)

export default component.exports